import { InjectionToken, isDevMode } from '@angular/core';

import { SbSDKOptions, storyblokInit } from '@storyblok/js';
import StoryblokClient from 'storyblok-js-client';

export function fetchWithCookiesEnabled(
	input: string | URL | globalThis.Request,
	init?: RequestInit,
) {
	if (isDevMode()) {
		if (init) {
			init.credentials = 'include';
		}
	}

	return fetch(input, init);
}

export const SB_CLIENT_FACTORY = new InjectionToken<
	typeof initializeStoryblokClient
>('storyblok-client-factory');

export function initializeStoryblokClient(
	accessToken: string,
	endpoint: string | null,
): StoryblokClient | undefined {
	return storyblokInit({
		accessToken,
		use: [
			// This is a modified ApiFactory, just to be able to alter the endpoint parameter in the
			// StoryblokClient
			(options: SbSDKOptions) => {
				const { apiOptions } = options;
				/* v8 ignore start */
				if (!apiOptions?.accessToken) {
					console.error(
						'You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication',
					);
					return {};
				}
				/* v8 ignore stop */
				const storyblokApi = new StoryblokClient(
					{
						...apiOptions,
						cache: {
							clear: 'auto',
							type: 'memory',
						},
						fetch: fetchWithCookiesEnabled,
					},
					endpoint ?? '',
				);
				return { storyblokApi };
			},
		],
	}).storyblokApi;
}
